import { render } from "./Well.vue?vue&type=template&id=ca490284&scoped=true"
import script from "./Well.vue?vue&type=script&lang=js"
export * from "./Well.vue?vue&type=script&lang=js"

import "./Well.vue?vue&type=style&index=0&id=ca490284&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca490284"]])

export default __exports__